import React from 'react';

const CaretLeft = props => {
  return (
    <svg
      width="9"
      height="16"
      viewBox="0 0 9 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 0.5L1 8L8.5 15.5"
        stroke="#081736"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CaretLeft;



// WEBPACK FOOTER //
// ./src/svg/CaretLeft.js